import { useSessionStorage } from "@mantine/hooks";
import { useCallback } from "react";

// Constants
export const CARD_AUTORESIZE_STORAGE_KEY = "local-autoresize-settings";
const STORAGE_KEY = CARD_AUTORESIZE_STORAGE_KEY;
const CARD_PREFIX = "card-";

export function useCardAutoResize(shapeId?: string) {
	const storageKey = `${CARD_PREFIX}${shapeId}`;

	const [autoResizeIds, setAutoResizeIds, removeAutoResizeIds] =
		useSessionStorage<string[]>({
			key: STORAGE_KEY,
			defaultValue: [],
			getInitialValueInEffect: false,
			sync: false,
		});

	if (!Array.isArray(autoResizeIds)) {
		removeAutoResizeIds();
	}

	// If ID exists in array, it's true; if absent, it's false
	const autoResize = Array.isArray(autoResizeIds)
		? autoResizeIds.includes(storageKey)
		: false;

	const setAutoResize = useCallback(
		(newAutoResize: boolean) => {
			// Use the current state value to ensure we have the latest array
			const currentIds = Array.isArray(autoResizeIds) ? autoResizeIds : [];

			if (newAutoResize) {
				// Add ID to array if not already present
				if (!currentIds.includes(storageKey)) {
					setAutoResizeIds([...currentIds, storageKey]);
				}
			} else {
				// Remove ID from array
				setAutoResizeIds(currentIds.filter((id) => id !== storageKey));
			}
		},
		[storageKey, autoResizeIds, setAutoResizeIds],
	);

	return {
		autoResize,
		setAutoResize,
		removeAutoResizeIds,
	};
}
